import { useTranslation } from 'react-i18next';
import parseTranslation from '../../../../utils/parse-translation';

const useEventInfo = () => {
  const { t } = useTranslation();

  const events = [
    {
      key: 'workshop',
      title: t('v2.offeringOverview.drawer_label_aboutWorkshop'),
      description: t('v2.offeringOverview.drawer_descriptionList_workshop'),
    },
    {
      key: 'exchangeGroup',
      title: t('v2.global.label_exchangeGroup'),
      description: t(
        'v2.offeringOverview.drawer_descriptionList_exchangeGroup',
      ),
    },
    {
      key: 'webinar',
      title: t('v2.offeringOverview.drawer_label_aboutWebinar'),
      description: t('v2.offeringOverview.drawer_descriptionList_webinar'),
    },
    {
      key: 'exercises',
      title: t('v2.offeringOverview.drawer_label_aboutExercises'),
      description: t('v2.offeringOverview.drawer_descriptionList_exercise'),
    },
    {
      key: 'meditations',
      title: t('v2.offeringOverview.drawer_label_aboutLiveMeditations'),
      description: t('v2.offeringOverview.drawer_descriptionList_meditation'),
    },
  ];

  const eventsWithBullets = events
    .map((item) => ({ ...item, bullets: parseTranslation(item.description) }))
    .filter((item) => item.bullets);

  return eventsWithBullets;
};

export default useEventInfo;
